import React, { createContext, useContext, useEffect, useState, useCallback } from "react";

const ItineraryContext = createContext(null);
const KEY = "ra_itinerary";

export function ItineraryProvider({ children }) {
  const [ids, setIds] = useState(() => {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch { return []; }
  });
  useEffect(() => {
    try { localStorage.setItem(KEY, JSON.stringify(ids)); } catch { /* ignore */ }
  }, [ids]);

  const add = useCallback((id) => setIds((p) => (p.includes(id) ? p : [...p, id])), []);
  const remove = useCallback((id) => setIds((p) => p.filter((x) => x !== id)), []);
  const clear = useCallback(() => setIds([]), []);

  return (
    <ItineraryContext.Provider value={{ ids, add, remove, clear }}>
      {children}
    </ItineraryContext.Provider>
  );
}

export const useItinerary = () => useContext(ItineraryContext);
